import { render, staticRenderFns } from "./scoreInfo.vue?vue&type=template&id=7587b6f5&scoped=true&"
import script from "./scoreInfo.vue?vue&type=script&lang=js&"
export * from "./scoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./scoreInfo.vue?vue&type=style&index=0&id=7587b6f5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7587b6f5",
  null
  
)

export default component.exports